module.exports = __webpack_public_path__ + "img/icon-unselected.1de61446.svg";